const BASE = process.env.VUE_APP_ENV === 'preview' ? 'api/spero-auth-service-staging' : 'api/spero-auth-service'
const urls = {
  anonyLogin: 'post /public/v1/anonymity/login',

  wxlogin: 'post /public/v1/oauth/login',
  upcLogin: 'post /public/oath/upc',

  /*
  * 手机号-验证码登录
  * phone: type: "string"
  * verifyCode: type: "string"
  * */
  phoneLogin: 'post /public/v1/sms/login',
}

const URLS = {}
for (let k in urls) {
  const arr = urls[k].split(' ')
  URLS[k] = `${arr[0]} ${BASE}${arr[1]}`
}

export default URLS
